import { ORGANIZATION_TYPE_INFLUENCER, ORGANIZATION_TYPE_INFLUENCERS_AGENCY } from 'utils/organization';

import { APPROVAL_STATUS_APPROVED, getApprovalStatus } from 'utils/profile';

import type { ApprovalStatus, Organization } from 'types';

type OrganizationType =
  | 'brand'
  | 'approved-brand'
  | 'influencer'
  | 'influencers_agency'

interface LikeOrganization {
  type: Organization['type'],
  influencerProfiles?: Array<unknown>,
  brandProfiles?: Array<{ approvalStatus?: ApprovalStatus }>
}

export const getOrganizationType = (organization: LikeOrganization): OrganizationType => {
  if (organization.type === ORGANIZATION_TYPE_INFLUENCERS_AGENCY) {
    return 'influencers_agency';
  }

  if (organization.type === ORGANIZATION_TYPE_INFLUENCER && organization.influencerProfiles) {
    return 'influencer';
  }

  const brandProfiles = organization.brandProfiles ?? [];
  const hasApprovedBrandProfile = brandProfiles.length > 0
    && getApprovalStatus(brandProfiles[0]) === APPROVAL_STATUS_APPROVED;

  if (hasApprovedBrandProfile) {
    return 'approved-brand';
  }

  return 'brand';
};
